import { render, staticRenderFns } from "./TabOdontologos.vue?vue&type=template&id=8266d844&scoped=true&"
import script from "./TabOdontologos.vue?vue&type=script&lang=js&"
export * from "./TabOdontologos.vue?vue&type=script&lang=js&"
import style0 from "./TabOdontologos.vue?vue&type=style&index=0&id=8266d844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8266d844",
  null
  
)

export default component.exports